import React from 'react';

export interface CheckIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m20.334 6.5-11 11-5-5"/>
    </svg>
  );
};

export default CheckIcon;
